






















import Vue from 'vue'
import { createComponent, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'
export default createComponent({
    props: {
        isOrigin: {
            type: Boolean,
            default: false,
        },
    },
})
